import module from 'fan/proyecto/module.js'
import template from './template.html'

export class FanProyectoColaboradoresMigrarConfirmarComponent {
  constructor ($state, FanProyectoColaboradoresMigrarService) {
    this.$state = $state
    this.FanProyectoColaboradoresMigrarService = FanProyectoColaboradoresMigrarService
    this.completando = null
    this.completado = null
    this.cuentasBancarias = true
    this.error = null
    this.onClose = null
    this.origen = null
    this.seleccionados = null
    this.notas = ''
    this.fecha_baja = null
    this.destino = null
    this.fecha_alta = null
  }

  iniciar () {
    if (this.completando) return
    this.completando = true
    this.error = null

    let data = this.seleccionados.map((item) => {
      return {
        'id_colaborador': item.id_colaborador,
        'id_proyecto': item.id_proyecto,
        'rfc': item.rfc,
      }
    })
    this.FanProyectoColaboradoresMigrarService.post(this.fecha_alta, this.fecha_baja, this.destino, this.origen, data, this.notas, this.cuentasBancarias ? 1 : 0)
      .then(() => (this.completado = true))
      .catch((error) => (this.error = error.data))
      .finally(() => (this.completando = false))
  }

  cerrar (completo) {
    if (completo) {
      this.$state.go('proyecto.colaboradores.lista')
    }
    this.onClose()
  }
}

module.component('fanProyectoColaboradoresMigrarConfirmar', {
  controller: FanProyectoColaboradoresMigrarConfirmarComponent,
  template,
  bindings: {
    origen: '<',
    seleccionados: '<',
    destino: '<',
    onClose: '&',
  }

})



// WEBPACK FOOTER //
// ./src/fan/proyecto/components/colaboradores/editar/migrar/confirmar/compoenent.js